import { SingleSelect } from '@predoc/cow';
import { useGetProviderTypes } from '../hooks/usersApi';

export const ProviderTypesDropdown = ({
  enabled,
  value,
  onChange,
}: {
  enabled: boolean;
  value: string;
  onChange: (value: string) => void;
}) => {
  const { data: providerTypes = [] } = useGetProviderTypes({ enabled });

  return (
    <SingleSelect
      options={providerTypes}
      value={value}
      handleChange={onChange}
      placeholder="Select provider type"
      className="w-full"
    />
  );
};
